module.exports = __webpack_public_path__ + "static/media/redeem.47e10a73.wav";